import React, { useEffect, useRef } from 'react';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

export const CheckoutSuccess: React.FC = () => {
  const { refreshSubscriptionStatus } = useAuth();
  const hasRefreshed = useRef(false);

  useEffect(() => {
    // Only refresh once when component mounts
    if (!hasRefreshed.current) {
      hasRefreshed.current = true;
      refreshSubscriptionStatus();
    }
  }, [refreshSubscriptionStatus]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-8 h-8 text-green-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Subscription Activated! 🎉
        </h1>
        
        <p className="text-gray-600 mb-6">
          Your premium subscription has been activated. You can now save and manage your mortgage analyses.
        </p>
        
        <div className="space-y-4">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h3 className="font-medium text-green-800 mb-2">What's Next?</h3>
            <ul className="text-sm text-green-700 space-y-1">
              <li>• Save unlimited analyses</li>
              <li>• Display up to 6 analyses at once</li>
            </ul>
          </div>
          
          <div className="flex gap-3">
            <button
              onClick={() => window.location.href = '/'}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Calculator
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
